import React from 'react';
import { motion } from 'framer-motion';
export function Slide16BusinessModel() {
  const models = [{
    title: 'Finns i Sjön',
    items: ['Per sample fee', 'Premium spots', 'Data insights'],
    color: '#4fd1c5'
  }, {
    title: 'Co‑Brand Sampling™',
    items: ['Shared cost model', 'Event activation fee'],
    color: '#ffd700'
  }, {
    title: 'SponsrAI',
    items: ['SaaS Subscription', 'Freemium → Pro'],
    color: '#f472b6'
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-199">
      <motion.h2 className="text-5xl font-bold text-white mb-20 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-200">
        Business Model
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-201">
        {models.map((model, i) => <motion.div key={i} initial={{
        y: 50,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.2,
        type: 'spring'
      }} className="flex flex-col h-full" data-id="element-202">
            <div className="h-2 rounded-t-xl w-full" style={{
          backgroundColor: model.color
        }} data-id="element-203" />
            <div className="flex-1 bg-white/5 border border-white/10 p-8 rounded-b-xl hover:bg-white/10 transition-colors" data-id="element-204">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-205">
                {model.title}
              </h3>
              <ul className="space-y-4" data-id="element-206">
                {model.items.map((item, j) => <li key={j} className="flex items-center gap-3 text-white/80" data-id="element-207">
                    <div className="w-1.5 h-1.5 rounded-full bg-white/50" data-id="element-208" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>)}
      </div>
    </div>;
}